<template>
  <HourlyChauffeur />
</template>
<script>
import HourlyChauffeur from "@/components/master/hourlyTariff/HourlyChauffeur";
export default {
  components: {
    HourlyChauffeur,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/sellingTariff/HourlyChauffeurSelling.vue